/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { LoginResponse } from '../model/models';
import { PasskeyCheckResponse } from '../model/models';
import { PasskeyLoginOptionsForm } from '../model/models';
import { PasskeyLoginOptionsResponse } from '../model/models';
import { PasskeyLoginVerifyForm } from '../model/models';
import { PasskeyRegistrationOptionsResponse } from '../model/models';
import { PasskeyRegistrationVerifyForm } from '../model/models';
import { PasskeyStatusResponse } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CheckPasskeyDisponibileRequestParams {
    userHandle: string;
}

export interface DeletePasskeyRequestParams {
    credentialId: string;
}

export interface GetPasskeyLoginOptionsRequestParams {
    passkeyLoginOptionsForm: PasskeyLoginOptionsForm;
}

export interface VerifyPasskeyLoginRequestParams {
    passkeyLoginVerifyForm: PasskeyLoginVerifyForm;
}

export interface VerifyPasskeyRegisterRequestParams {
    passkeyRegistrationVerifyForm: PasskeyRegistrationVerifyForm;
}


export interface PasskeyWebAuthnServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Verifica disponibilità passkey per utente
     * Controlla se l\&#39;utente identificato dall\&#39;handle opaco user_handle (il user_id Base64URL emesso da /register/options) ha almeno una passkey registrata e non scaduta. Handle sconosciuto/malformato → available&#x3D;false (privacy-preserving). Endpoint pubblico.
     * @endpoint get /api/v1/passkey/check
* @param requestParameters
     */
    checkPasskeyDisponibile(requestParameters: CheckPasskeyDisponibileRequestParams, extraHttpRequestParams?: any): Observable<PasskeyCheckResponse>;

    /**
     * Revoca tutte le passkey
     * Elimina tutte le credenziali WebAuthn dell\&#39;utente autenticato.
     * @endpoint delete /api/v1/passkey/revoke-all
*/
    deleteAllPasskey(extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Revoca una singola passkey
     * Elimina la credenziale WebAuthn identificata dal credentialId. Verifica che appartenga all\&#39;utente autenticato.
     * @endpoint delete /api/v1/passkey/{credential_id}
* @param requestParameters
     */
    deletePasskey(requestParameters: DeletePasskeyRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Genera opzioni login passkey
     * Genera challenge e lista di credenziali ammesse per il login via passkey. L\&#39;utente e\&#39; identificato dall\&#39;handle opaco user_handle (il user_id Base64URL emesso da /register/options), non dall\&#39;email. Endpoint pubblico.
     * @endpoint post /api/v1/passkey/login/options
* @param requestParameters
     */
    getPasskeyLoginOptions(requestParameters: GetPasskeyLoginOptionsRequestParams, extraHttpRequestParams?: any): Observable<PasskeyLoginOptionsResponse>;

    /**
     * Genera opzioni registrazione passkey
     * Genera challenge e parametri per registrare una nuova passkey sul dispositivo del genitore.
     * @endpoint post /api/v1/passkey/register/options
*/
    getPasskeyRegisterOptions(extraHttpRequestParams?: any): Observable<PasskeyRegistrationOptionsResponse>;

    /**
     * Stato passkey utente autenticato
     * Restituisce la lista dei dispositivi con passkey registrate, con dettagli di scadenza e ultimo utilizzo.
     * @endpoint get /api/v1/passkey/status
*/
    getPasskeyStatus(extraHttpRequestParams?: any): Observable<PasskeyStatusResponse>;

    /**
     * Verifica login passkey e ottieni token
     * Verifica l\&#39;assertion WebAuthn, scambia il refresh token salvato con KC e restituisce i token di accesso. Endpoint pubblico.
     * @endpoint post /api/v1/passkey/login/verify
* @param requestParameters
     */
    verifyPasskeyLogin(requestParameters: VerifyPasskeyLoginRequestParams, extraHttpRequestParams?: any): Observable<LoginResponse>;

    /**
     * Verifica e salva registrazione passkey
     * Verifica l\&#39;attestation prodotta dal browser/authenticator, salva la credenziale e associa il refresh token KC.
     * @endpoint post /api/v1/passkey/register/verify
* @param requestParameters
     */
    verifyPasskeyRegister(requestParameters: VerifyPasskeyRegisterRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

}
